// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"8becf370","712":"771176bf"}[chunkId] + ".chunk.js";
};